import { getApiUrl } from '@/config/api'
import { createSubmitter } from './api'
import type { NeedsAnalysisResponse, NeedsAnalysisSubmissionRequest } from '@/types/learner-portal'

export const needsAnalysisService = {
  // Get status URL for SWR
  getStatusUrl: () => getApiUrl('/needs-analysis'),

  // Submit survey
  async submitNeedsAnalysis(
    data: NeedsAnalysisSubmissionRequest,
    getToken: () => Promise<string | null>
  ): Promise<NeedsAnalysisResponse> {
    const submitter = createSubmitter(getToken)
    return await submitter('/needs-analysis', data)
  },
}
